<app-layout>
  <div class="home">
    <img
      class="logotipo"
      [src]="brand.logoHome"
      alt="Logo" />
    <div class="buttons">
      <div
        class="button"
        *ngIf="isModuloAtivo('GateEntrada') && viewMenu('cadastrarGateEntrada', 'incluir')"
        (click)="useNavigate('cadastro/entrada')">
        <img src="assets/icons/entrada-gate.svg" />
        <span>Gate de Entrada</span>
      </div>
      <div
        class="button"
        *ngIf="isModuloAtivo('GateSaida') && viewMenu('cadastrarGateSaida', 'incluir')"
        (click)="useNavigate('cadastro/saida-gate')">
        <img src="assets/icons/saida-gate.svg" />
        <span>Gate de Saída</span>
      </div>
      <div
        class="button"
        *ngIf="false"
        (click)="useNavigate('cadastro/desengate')">
        <img src="assets/icons/desengate.svg" />
        <span>Desengate</span>
      </div>
      <div
        class="button"
        *ngIf="false"
        (click)="useNavigate('cadastro/engate')">
        <img src="assets/icons/engate.svg" />
        <span>Engate</span>
      </div>
      <div
        class="button"
        *ngIf="isModuloAtivo('ServicoEntrada') && viewMenu('cadastrarServico', 'incluir')"
        (click)="useNavigate('cadastro/servicos')">
        <img src="assets/icons/servicos.svg" />
        <span>Entrada de Serviço</span>
      </div>
      <div
        class="button"
        *ngIf="isModuloAtivo('LaudoServico') && viewMenu('cadastrarLaudoHigienizacao', 'incluir')"
        (click)="useNavigate('cadastro/laudo-higienizacao')">
        <img src="assets/icons/laudos-higienizacao.svg" />
        <span>Laudo de Higienização</span>
      </div>
    </div>
  </div>
</app-layout>
